import { createFileRoute } from '@tanstack/react-router'
import { CheckInPage } from '#pages/client/CheckInPage'

export const Route = createFileRoute('/_app/checkin')({
  component: CheckInPage,
})
